// src/ConsoleUser.js
import './asset/App.css';
import Header from './component/Header';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import { DataGrid, GridToolbar, zhTW } from '@mui/x-data-grid';

const columns = [
    { field: 'createdAt', headerName: '創立日期', width: 180 },
    { field: 'fullName', headerName: '姓名', width: 100 },
    { field: 'username', headerName: '信箱', width: 150 },
    { field: 'companyId', headerName: '統一編號', width: 80 },
    { field: 'companyName', headerName: '公司名稱', width: 80 },
    { field: 'regularPoints', headerName: '訂閱點數', width: 60 },
    { field: 'bonusPoints', headerName: '額外點數', width: 60 },
    { field: 'option', 
      headerName: '選項', 
      width: 100,
      renderCell: (params) => {
        // you will find row info in params
        return(      
          <Button component={Link} to={`/consoleform?id=${params.row.id}`} variant="contained" color="primary">
            查看
          </Button>
      )} 
    },
    { field: 'loginAt', headerName: '上線日期', width: 180 }
  ];

function ConsoleUser() {
    //const navigate = useNavigate();
    const [rows, setRows] = useState([]); 

    useEffect(() => {
        axios.get(`https://macct.tw/api/userList`)
        .then((response) => {
            if (response.data.success) {
                console.log(response.data);
                const rowData = response.data.data.map(form => createData(
                        form.createdAt, 
                        form.fullname,
                        form.username, 
                        form.companyId, 
                        form.companyName, 
                        form.regularPoints,
                        form.bonusPoints, 
                        form._id,
                        form.loginAt, 
                    ));
                setRows(rowData);
                console.log(rowData);
            } else {
                alert("資料有誤或無使用者");
            }
        })
        .catch((error) => {
            console.error('Error:', error);
            //navigate('/');
        });
    }, []);

      //row data to pretty form
    function createData(createdAt, fullName, username, companyId, companyName, regularPoints, bonusPoints, id, loginAt) {
        return { createdAt, fullName, username, companyId, companyName, regularPoints, bonusPoints, id, loginAt };
    }

    const handleBeta = () => {
        alert("功能製作中, 待完整版推出");
      };

    // 渲染页面内容
    return (
      <div className="App">
        <Header />
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '95%', margin: 'auto' }}>
            <Typography variant="h4" sx={{ textAlign: 'left', mt: 3, mb: 3 }}>
                用戶資料
            </Typography>
        </div>
        <Paper sx={{ width: '90%', overflow: 'hidden', m:"auto" }}>
            <div style={{ height: 900, width: '100%' }}>
                <DataGrid 
                    rows={rows} 
                    columns={columns} 
                    disableColumnSelector
                    slots={{ toolbar: GridToolbar }}
                    slotProps={{
                      toolbar: {
                          showQuickFilter: true,
                          printOptions: { disableToolbarButton: true },
                          csvOptions: { disableToolbarButton: true },
                      }
                    }}
                    localeText={zhTW.components.MuiDataGrid.defaultProps.localeText}
                />
            </div>
        </Paper>
      </div>
    );
  }
  
  export default ConsoleUser;